import { render, staticRenderFns } from "./hero17.vue?vue&type=template&id=457759a1&scoped=true"
import script from "./hero17.vue?vue&type=script&lang=js"
export * from "./hero17.vue?vue&type=script&lang=js"
import style0 from "./hero17.vue?vue&type=style&index=0&id=457759a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457759a1",
  null
  
)

export default component.exports